import React from "react";
import ReactDOM from "react-dom";
import Button from "../MaterialUi/Button";
import { modal } from "../AsyncModal";
import BaufiImplecoLeadPage from "./BaufiImplecoLeadPage";
import Affiliate from "../../utils/Affiliate";
import useUser from "../../stores/useUser";

export interface IBaufiImplecoLeadPortalProps {
    className?: string;
}

const container = document.getElementsByClassName('wgl-service-link')[0] as HTMLElement;
const parent = container.parentElement;

const BaufiImplecoLeadPortal: React.FC <IBaufiImplecoLeadPortalProps> = ({ className = '' }) => {

    if (!container) {
        return null; // don't render anything, we are on a Drupal landing page 
    }

    const [user]= useUser();
    const browserAffiliate = Affiliate.getBrowserAffiliate();
    
    if (!user.isInitialized) {
        return;
    }

    const affiliateId = user?.affiliateName || browserAffiliate;
    const isLeadSmartModal = parent && !Affiliate.isBankAffiliate(affiliateId);

    const openLeadSmartModal = () => { 
        modal(<BaufiImplecoLeadPage />, 
            {title: 'Baufinanzierungs-Check', maxWidth: 'md', disableBackdropClick: true})
            .catch(() => {/*close*/});
    }

    if (isLeadSmartModal) {
        // hide, not remove to avoid bugs on rerendering
        container.classList.add('hidden');
        container.ariaHidden = 'true';
    } else {
        container.classList.remove('hidden');
        container.ariaHidden = 'false';
    }

    return isLeadSmartModal ? ReactDOM.createPortal(<Button size="extraLarge" onClick={openLeadSmartModal}>Günstige Finanzierung sichern</Button>, parent) : null;
};

export default BaufiImplecoLeadPortal;
